import { useTheme } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import React, { useEffect, useState } from "react";
import chartNewBgDark from "../../assets/bg-image-swap/bg-chart-dark.svg";
import chartNewBg from "../../assets/bg-image-swap/bg-chart-light.svg";
import CustomTooltip from "../../components/CustomTooltip.jsx";
import FailedTransaction from "../../components/FailedTransaction.jsx";
import LoaderComponent from "../../components/LoaderComponent.jsx";
import NewLPFarmComponent from "../../components/NewLPFarm.jsx";
import ShowToast from "../../components/showToast.js";
import LayoutHeader from "../../layouts/LayoutMain/components/LayoutHeader/LayoutHeader.jsx";
import NewLiquidityComponent from "../NewLiqudity/newLiquidity.jsx";
import NewSwapComponent from "../NewSwap/newSwap.jsx";
import LPFarmComponent from "../lpFarm.jsx";
import TabButton from "./TabButton/TabButton.jsx";

const NewFarm = () => {
  const theme = useTheme();
  const alt = theme.palette.background.alt;
  const [activeSection, setActiveSection] = useState(
    parseInt(localStorage.getItem("activeTab")) || 1
  );
  const [isTransactionFailedOpen, setIsTransactionFailedOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSectionClick = (sectionNumber) => {
    setActiveSection(sectionNumber);
    localStorage.setItem("activeTab", sectionNumber.toString());
  };

  const fetchUsdtPrice = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/v1/xbr/usdt-price`
      );
      return response.data?.usd;
    } catch (error) {
      console.error("Error in fetching USDT Price", error);
    }
  };

  const openFailedTransactionModal = () => {
    setIsTransactionFailedOpen(true);
  };

  const closeFailedTransactionModal = () => {
    setIsTransactionFailedOpen(false);
  };

  return (
    <section className="relative pt-7 pb-[90px] md:pt-13 md:pb-25 mobile:px-2 max-w-screen-xl mx-auto">
      <LayoutHeader />

      <img
        src={chartNewBg}
        alt="Background chart"
        className="hidden dark:lg:hidden absolute lg:block top-0 right-0 left-0 mx-auto"
      />
      <img
        src={chartNewBgDark}
        alt="Background chart"
        className="hidden absolute dark:lg:block top-0 right-0 left-0 mx-auto"
      />
      <div className={"pb-5 relative "}>
        {loading && (
          <LoaderComponent transactionText="Transaction is in progress..." />
        )}
        <div>
          <div className="max-w-140 bg-white dark:bg-darkCardBg flex-col font-inter mx-auto items-center justify-center z-10 pb-1 px-4 pt-4 rounded-t-3xl">
            {/* Tab Section */}

            <div className="w-full">
              {/* Tab buttons */}
              <div
                className={
                  "w-full flex items-center justify-between box-border bg-white dark:bg-darkCardBg mb-4"
                }
              >
                <TabButton
                  handleClick={handleSectionClick}
                  activeTab={activeSection}
                  tabValue={1}
                >
                  Swap
                </TabButton>
                {/* Liquidity Button (Disabled) with Tooltip */}

                <TabButton
                  handleClick={handleSectionClick}
                  activeTab={activeSection}
                  tabValue={2}
                >
                  Liquidity
                </TabButton>

                {/* LP Farm Button (Disabled) with Tooltip */}

                <TabButton
                  handleClick={handleSectionClick}
                  activeTab={activeSection}
                  tabValue={3}
                  disabled={true}
                >
                  <CustomTooltip content="Coming Soon">LP Farm</CustomTooltip>
                </TabButton>
              </div>
            </div>
          </div>
          <div>
            {activeSection === 1 && (
              <NewSwapComponent fetchUsdtPrice={fetchUsdtPrice} />
            )}
            {activeSection === 2 && (
              <NewLiquidityComponent
                fetchUsdtPrice={fetchUsdtPrice}
                setMainActiveSection={setActiveSection}
              />
            )}
            {activeSection === 3 && (
              <NewLPFarmComponent
                fetchUsdtPrice={fetchUsdtPrice}
                setMainActiveSection={setActiveSection}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFarm;
